import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc5f683"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breathing_exercise" }
const _hoisted_2 = {
  class: "breathing_exercise__header",
  "data-test": "ex-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("ex.title")), 1),
    _createVNode(_component_router_view, { "data-test": "ex-router" })
  ]))
}